var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "<div>\n	<div class=\"search-section\">\n		<input type=\"text\" placeholder=\""
    + alias3(((helper = (helper = helpers.placeholderText || (depth0 != null ? depth0.placeholderText : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"placeholderText","hash":{},"data":data}) : helper)))
    + "\" />\n		<i class=\"icon-ic_search_black_24px\"></i>\n		<i class=\"icon-ic_close_black_24px reset\"></i>\n	</div>\n	<div class=\"results\"></div>\n	<div class=\"error-search-panel\">"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "</div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/components/autocomplete/autocomplete.hbs
// module id = 129
// module chunks = 1